var Mustache = require("mustache");
import Swiper from "swiper";
import swiperA11y from "./utils/swiperA11y";
import breakpointChecker from "./utils/breakpointChecker";
import config from "./utils/config";
import fundDetailTab from "./components/fundDetailTab";

(function ($) {
  if ($(".fund--esg").length > 0) {
    fundDetailTab();
    window.Sharer.init({
      callbackAPI: `esgCard__slider`,
    });
    let swiper = {};
    const enableSwiper = function (id) {
      if ($(`.esgCard__slider__${id} .esgCard__slide`).length > 3) {
        $(`.esgCard__slider__${id} .swiper-buttons`).show();
      } else {
        $(`.esgCard__slider__${id} .swiper-buttons`).hide();
      }
      $(`.esgCard__slider__${id}`).removeClass("esgCard__slider--static");
      let _swiper = new Swiper(`.esgCard__slider__${id}`, {
        autoplay: false,
        loop: false,
        grabCursor: true,
        watchSlidesVisibility: true,
        pagination: {
          el: `.esgCard__slider__${id} .swiper-pagination`,
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          320: {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 10,
          },
          // when window width is >= 992px
          992: {
            autoHeight: true,
            slidesPerView: 3,
            spaceBetween: 25,
          },
          1420: {
            autoHeight: true,
            slidesPerView: 3,
            spaceBetween: 55,
          },
        },
        navigation: {
          nextEl: `.esg__${id} .swiper-button-next`,
          prevEl: `.esg__${id} .swiper-button-prev`,
        },
        init: false,
        on: {
          init: function () {
            swiperA11y.toggleAriaHidden(_swiper, false);
          },
        },
        a11y: {
          paginationBulletMessage:
            document.documentElement.lang == "en"
              ? "Go to slide {{index}}"
              : "前往第{{index}}頁",
        },
      });

      _swiper.init();

      _swiper.on("transitionStart", function () {
        swiperA11y.toggleAriaHidden(_swiper, false);
      });
      swiper[id] = _swiper;
    };

    function destroySwiper(id) {
      if (!!swiper[id]) {
        swiper[id].destroy(true, true);
      }
      if ($(`.esgCard__slider__${id} .esgCard__slide`).length > 3) {
        $(`.esgCard__slider__${id} .swiper-buttons`).show();
      } else {
        $(`.esgCard__slider__${id} .swiper-buttons`).hide();
      }
      $(`.esgCard__slider__${id}`).addClass(`esgCard__slider--static`);
      $(`.esgCard__slider__${id} .esgCard__slide`)
        .removeAttr("aria-hidden")
        .find("a, button")
        .removeAttr("tabindex");
      $(`.esgCard__slider__${id}`)
        .removeAttr("aria-hidden")
        .find("a, button")
        .removeAttr("tabindex");
    }

    enableSwiper(1);
    // enableSwiper(2);

    let _approaches__slider = new Swiper(
      `.approaches__slider .swiper-container`,
      {
        autoplay: false,
        loop: false,
        grabCursor: true,
        watchSlidesVisibility: true,
        pagination: {
          el: `.approaches__slider .swiper-pagination`,
          type: "bullets",
          clickable: true,
        },
        slidesPerView: 1,
        init: false,
        autoHeight: false,
        a11y: {
          paginationBulletMessage:
            document.documentElement.lang == "en"
              ? "Go to slide {{index}}"
              : "前往第{{index}}頁",
        },
      },
    );
    _approaches__slider.init();

    //$(document).ready(function () {
    // $(".yourStake__item").hover(
    //   function () {
    //     $(this).find(".yourStake__desc").attr("aria-expanded", false);
    //   },
    //   function () {
    //     $(this).find(".yourStake__desc").attr("aria-expanded", true);
    //   }
    // );
    // $(".yourStake__item").focus(
    //   function () {
    //     console.log(this);
    //     if ($(this).find(".yourStake__desc").is(":visible")) {
    //       $(this).find(".yourStake__desc").attr("aria-expanded", false);
    //     } else {
    //       $(this).find(".yourStake__desc").attr("aria-expanded", true);
    //     }
    //   },
    //   function () {
    //     $(this).find(".yourStake__desc").attr("aria-expanded", true);
    //   }
    // );
    //});
  }
})(hsvmJQuery);
